/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateExchangeRateInput = {
    currency?: string | null | undefined;
    rate?: number | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createExchangeRateMutationVariables = {
    input: CreateExchangeRateInput;
};
export type createExchangeRateMutationResponse = {
    readonly createExchangeRate: {
        readonly exchangeRate: {
            readonly node: {
                readonly id: string;
                readonly currency: string | null;
                readonly rate: number | null;
                readonly isUsed: boolean | null;
            } | null;
        } | null;
    } | null;
};
export type createExchangeRateMutation = {
    readonly response: createExchangeRateMutationResponse;
    readonly variables: createExchangeRateMutationVariables;
};



/*
mutation createExchangeRateMutation(
  $input: CreateExchangeRateInput!
) {
  createExchangeRate(input: $input) {
    exchangeRate {
      node {
        id
        currency
        rate
        isUsed
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateExchangeRateInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateExchangeRatePayload",
    "kind": "LinkedField",
    "name": "createExchangeRate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExchangeRateTypeEdge",
        "kind": "LinkedField",
        "name": "exchangeRate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExchangeRate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsed",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createExchangeRateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createExchangeRateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createExchangeRateMutation",
    "operationKind": "mutation",
    "text": "mutation createExchangeRateMutation(\n  $input: CreateExchangeRateInput!\n) {\n  createExchangeRate(input: $input) {\n    exchangeRate {\n      node {\n        id\n        currency\n        rate\n        isUsed\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '2e88a25f5ffd59ae6bcb7f83be4d4a0d';
export default node;
